import { render, staticRenderFns } from "./GTextView.vue?vue&type=template&id=dab50f18&scoped=true&"
import script from "./GTextView.vue?vue&type=script&lang=ts&"
export * from "./GTextView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab50f18",
  null
  
)

export default component.exports